export * from '@primeuix/themes/material/speeddial';
export { default } from '@primeuix/themes/material/speeddial';
